import React from 'react';
import Announce from './Announce';

const AnnounceContainer = (props: Record<string, any>) => <Announce {...props} />;

export default AnnounceContainer;
